import pxToRem from "../../functions/pxToRem";

// Hairlines between rows; header cells take the grids' muted, semibold labels and firmer rule.
export default function tableCell({ borders, tokens }) {
  const { borderWidth } = borders;

  const tableCell = {
    styleOverrides: {
      root: {
        padding: `${pxToRem(12)} ${pxToRem(16)}`,
        borderBottom: `${borderWidth[1]} solid ${tokens.border}`,
      },

      head: {
        fontWeight: 600,
        color: tokens["text-2"],
        borderBottomColor: tokens["border-strong"],
      },
    },
  };

  return tableCell;
}
